/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Tessera Backend API
 * Tessera backend application with Bearer token authentication and multi-tenant support
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  InvalidateOptions,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../api-instance';
import { apiInstance } from '../api-instance';
import type { TLReleaseStatus } from './tessera-backend-api.schemas';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get Release Status
 */
export const getReleaseStatus = (options?: SecondParameter<typeof apiInstance>, signal?: AbortSignal) => {
  return apiInstance<TLReleaseStatus>({ url: `/releases/status`, method: 'GET', signal }, options);
};

export const getGetReleaseStatusQueryKey = () => {
  return ['releases', 'status'] as const;
};

export const getGetReleaseStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getReleaseStatus>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleaseStatus>>, TError, TData>>;
  request?: SecondParameter<typeof apiInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetReleaseStatusQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReleaseStatus>>> = ({ signal }) =>
    getReleaseStatus(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReleaseStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReleaseStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getReleaseStatus>>>;
export type GetReleaseStatusQueryError = ErrorType<unknown>;

export function useGetReleaseStatus<TData = Awaited<ReturnType<typeof getReleaseStatus>>, TError = ErrorType<unknown>>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleaseStatus>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReleaseStatus>>,
          TError,
          Awaited<ReturnType<typeof getReleaseStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReleaseStatus<TData = Awaited<ReturnType<typeof getReleaseStatus>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleaseStatus>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReleaseStatus>>,
          TError,
          Awaited<ReturnType<typeof getReleaseStatus>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReleaseStatus<TData = Awaited<ReturnType<typeof getReleaseStatus>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleaseStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Release Status
 */

export function useGetReleaseStatus<TData = Awaited<ReturnType<typeof getReleaseStatus>>, TError = ErrorType<unknown>>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleaseStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetReleaseStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * @summary Get Release Status
 */
export const prefetchGetReleaseStatusQuery = async <
  TData = Awaited<ReturnType<typeof getReleaseStatus>>,
  TError = ErrorType<unknown>,
>(
  queryClient: QueryClient,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReleaseStatus>>, TError, TData>>;
    request?: SecondParameter<typeof apiInstance>;
  },
): Promise<QueryClient> => {
  const queryOptions = getGetReleaseStatusQueryOptions(options);

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
};

/**
 * @summary Get Release Status
 */
export const invalidateGetReleaseStatus = async (
  queryClient: QueryClient,
  options?: InvalidateOptions,
): Promise<QueryClient> => {
  await queryClient.invalidateQueries({ queryKey: getGetReleaseStatusQueryKey() }, options);

  return queryClient;
};
